import { render, staticRenderFns } from "./NominaResponsabileReview.vue?vue&type=template&id=1d4c776a&scoped=true&"
import script from "./NominaResponsabileReview.vue?vue&type=script&lang=ts&"
export * from "./NominaResponsabileReview.vue?vue&type=script&lang=ts&"
import style0 from "./NominaResponsabileReview.vue?vue&type=style&index=0&id=1d4c776a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4c776a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCol,VRow})
